import { AloftPrice } from '@aloft/toolkit-shared';

import { useMemo } from 'react';

import { MarketTrendsSummary } from './marketTrends/MarketTrendsSummary.js';
import { getMarketTrendsHelpers } from './marketTrends/getMarketTrendsHelpers.js';
import { Tkv2MarketConditionsExportDeps, Tkv2MarketConditionsState } from './types.js';
import { getCompsWithSaleInfo } from './utils/getCompsWithSaleInfo.js';

type Props = {
  exportDeps?: Tkv2MarketConditionsExportDeps;
  state: Tkv2MarketConditionsState;
};

export function Tkv2MarketConditionsSummaryContent(props: Props) {
  return <DateOfSaleSummaryContent {...props} />;
}

// TODO: migrate other date of sale summary content into this component
function DateOfSaleSummaryContent(props: Props) {
  const {
    exportDeps,
    state: {
      effectiveDate,
      comps,
      dateOfSaleAdjustment: { methods, selectedMethod },
    },
  } = props;

  const { marketTrends } = methods ?? {};

  const compsWithSaleInfo = useMemo(() => {
    return getCompsWithSaleInfo(comps);
  }, [comps]);

  const marketTrendsHelpers = useMemo(() => {
    return marketTrends === undefined
      ? undefined
      : getMarketTrendsHelpers({
          effectiveDate,
          comps: compsWithSaleInfo,
          series: marketTrends.series,
          using: marketTrends.using,
          rounding: AloftPrice.fromDollarLike(100),
        });
  }, [effectiveDate, compsWithSaleInfo, marketTrends]);

  switch (selectedMethod) {
    case 'marketTrends':
      return (
        marketTrendsHelpers && (
          <MarketTrendsSummary
            exportDeps={exportDeps?.marketTrends}
            marketTrendsHelpers={marketTrendsHelpers}
          />
        )
      );
    default:
      // TODO: add the others to this list
      return null;
  }
}
